/**
 * Seller utilities for managing ads and marketplace
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const getStoredToken = () => {
  return localStorage.getItem('auth_token');
};

export const getSellerAds = async (filters = {}) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const params = new URLSearchParams();
    if (filters.game) params.append('game', filters.game);
    if (filters.service_type) params.append('service_type', filters.service_type);

    const response = await fetch(`${API_BASE_URL}/seller/ads?${params}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to fetch ads' } };
    }

    return { data: data.data || [], error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const createSellerAd = async (adData) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }
    // Always send quantity so API stores it (In stock / Qty)
    const payload = { ...adData };
    const q = payload.quantity;
    if (q === undefined || q === null || q === '') {
      payload.quantity = 1;
    } else {
      const n = typeof q === 'number' ? q : parseInt(String(q), 10);
      payload.quantity = Number.isNaN(n) || n < 1 ? 1 : n;
    }

    const response = await fetch(`${API_BASE_URL}/seller/ads`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to create ad' } };
    }

    return { data: data.data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const updateSellerAd = async (adId, adData) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/seller/ads/${adId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
      body: JSON.stringify(adData),
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to update ad' } };
    }

    return { data: data.data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

export const deleteSellerAd = async (adId) => {
  try {
    const token = getStoredToken();
    if (!token) {
      return { data: null, error: { message: 'Not authenticated' } };
    }

    const response = await fetch(`${API_BASE_URL}/seller/ads/${adId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    const data = await response.json();

    if (!response.ok) {
      return { data: null, error: { message: data.error || 'Failed to delete ad' } };
    }

    return { data: data, error: null };
  } catch (error) {
    return { data: null, error: { message: error.message || 'Network error' } };
  }
};

